import {useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import SearchList from '../../../../../sharedComponent/SearchList/SearchList'
import {CUSTOMERAUDITLISTCONFIGS} from './CustomerAuditUtils'
import {useLazyQuery} from '@apollo/client'
import {GET_TPVREPORTS_AUDIT} from '../../../../../../utils/GraphQLAPI'

const AuditTrail = ({
  tpvId,
  getTPVAuditList,
  auditData,
  filterOptions,
  setFilterOptions,
  auditDataLoading,
}: any) => {
  const [modalConfig, setModalConfig] = useState({
    show: false,
  })
  const handleModalClose = () => {
    setModalConfig((prev) => {
      return {...prev, show: false}
    })
  }
  const [getAudit, {loading: getLoading, data: audits}] = useLazyQuery(GET_TPVREPORTS_AUDIT)
  const modalsRoot = document.getElementById('root-modals') || document.body

  return (
    <>
      <SearchList
        idFieldName='id'
        filterOptions={filterOptions}
        setFilterOptions={setFilterOptions}
        listCount={auditData?.getTpvAuditListBySystemAdmin?.totalCount}
        paginatedCount={auditData?.getTpvAuditListBySystemAdmin?.recordList?.length}
        listLoading={auditDataLoading}
        isSearchable={false}
        apiData={auditData?.getTpvAuditListBySystemAdmin?.recordList}
        listConfigs={CUSTOMERAUDITLISTCONFIGS}
        onRowClick={(values: any) => {
          getAudit({
            variables: {email: values.userEmail, timeChanged: values.timeChanged, tpvId: tpvId},
          })
          setModalConfig((prev) => {
            return {...prev, show: true}
          })
        }}
        isActiveApiFieldName=''
      />
      {createPortal(
        <Modal
          id='kt-modal_create_app'
          tabIndex={-1}
          aria-hidden='true'
          dialogClassName='modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg'
          show={modalConfig.show}
          onHide={() => handleModalClose()}
          backdrop={true}
        >
          <div className='modal-header'>
            <h2>Activity Log</h2>
          </div>
          <div className='hover-scroll-overlay-y mh-550px product-form'>
            {getLoading ? (
              <div className='text-center h-300px'>
                <Spinner animation='border' className='text-gray-600' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </Spinner>
              </div>
            ) : (
              <div className='px-7 py-5'>
                <table className='table table-row-dashed table-row-gray-300 gy-7'>
                  <thead>
                    <tr className='fw-bold text-gray-800'>
                      <th className='fs-7'>Field</th>
                      <th className='fs-7'>Old Data</th>
                      <th className='fs-7'>New Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    {audits?.getTpvAuditBySystemAdmin?.changes?.length > 0 ? (
                      audits?.getTpvAuditBySystemAdmin?.changes.map((data: any) => (
                        <tr>
                          <td className='text-gray-600 fs-6'>{data?.fieldName}</td>
                          <td className='text-gray-600 fs-6'>{data?.oldValue}</td>
                          <td className='text-gray-600 fs-6'>{data?.newValue}</td>
                        </tr>
                      ))
                    ) : (
                      <p>No Changes</p>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div
            className='modal-footer sticky-bottom bg-white'
            style={{borderRadius: '0 0 20px 20px', zIndex: '2'}}
          >
            <button
              onClick={() => handleModalClose()}
              className='btn btn-light-primary'
              data-kt-stepper-action='submit'
            >
              Close
            </button>
          </div>
        </Modal>,
        modalsRoot
      )}
    </>
  )
}
export default AuditTrail
